import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.125 9.125H1.875C1.32292 9.125 0.875 8.67708 0.875 8.125V1.875C0.875 1.32292 1.32292 0.875 1.875 0.875H8.125C8.67708 0.875 9.125 1.32292 9.125 1.875V8.125C9.125 8.67708 8.67708 9.125 8.125 9.125Z"
          stroke="#7A8499"
          strokeMiterlimit="10"
        />
        <path d="M0.875 3.625H9" stroke="#7A8499" strokeMiterlimit="10" />
        <path
          d="M0.875 6.375H9.125"
          stroke="#7A8499"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M3.625 9.125V1" stroke="#7A8499" strokeMiterlimit="10" />
      </svg>
    </>
  );
};
